// Cliente da remocao de fundo IA no navegador (DA-072 -> client-side).
//
// O trabalho pesado (onnxruntime-web + modelo ISNet 1024²) roda num Web Worker
// (remover-fundo-worker.ts) — fora do thread principal, pra a tela nunca
// travar. Aqui so criamos o worker, repassamos o progresso e devolvemos o
// resultado como PNG transparente. O servidor faz so o master final (WebP
// lossless centrado), via /api/upload/melhorar-master?ja_recortada=true.

// Limite de seguranca: cancela se passar disso. Generoso porque a 1a request
// inclui o download do modelo (~171 MB) e a inicializacao do WASM.
const TIMEOUT_MS = 360000;

// Roda a IA no navegador e devolve a foto sem fundo (PNG transparente).
// onProgresso recebe { etapa, valor } pra alimentar a barra.
export function removerFundoNoNavegador(
  fotoUrl: string,
  onProgresso?: (e: { etapa: string; valor: number }) => void,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('./remover-fundo-worker.ts', import.meta.url), {
      type: 'module',
    });
    let encerrado = false;
    const encerrar = () => {
      if (encerrado) return;
      encerrado = true;
      clearTimeout(timer);
      worker.terminate();
    };
    const timer = setTimeout(() => {
      reject(new Error('a remocao de fundo demorou demais e foi cancelada — tente de novo'));
      encerrar();
    }, TIMEOUT_MS);

    worker.onmessage = (e: MessageEvent) => {
      const m = e.data;
      if (m?.tipo === 'progresso') {
        onProgresso?.({
          etapa: String(m.etapa || ''),
          valor: Math.min(1, Math.max(0, Number(m.valor) || 0)),
        });
      } else if (m?.tipo === 'pronto') {
        resolve(m.blob as Blob);
        encerrar();
      } else if (m?.tipo === 'erro') {
        reject(new Error(m.msg || 'falha ao retirar o fundo'));
        encerrar();
      }
    };
    worker.onerror = (e) => {
      reject(new Error(e.message || 'falha no processamento da imagem'));
      encerrar();
    };

    worker.postMessage({ fotoUrl });
  });
}
